import { Button } from '@moniebook-web/components/atoms/button';
import { Body, Title } from '@moniebook-web/components/atoms/typography';

export function InternetRequiredView() {
    const handleReload = () => {
        window.location.reload();
    };

    return (
        <div className='mb-48 flex size-full flex-col items-center justify-center'>
            <img
                src='/illustrations/cancel-transaction.svg'
                alt='Broken network'
                className='mb-48 h-72 w-220'
            />
            <Title className='mb-10 font-general-sans text-18 font-semibold text-content-subtext-default'>
                No internet connection
            </Title>
            <Body className='mb-24'>
                Connect to the internet to access this page
            </Body>
            <Button
                onClick={handleReload}
                theme='secondary'
                label='Reload page'
            />
        </div>
    );
}
